import { useMemo } from 'react';
import { User } from '@rossum/api-client/users';
import { useUnpaginatedUsers } from '../../../business/users/useUnpaginatedUsers';

export const getUserName = (user: User): string => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.email) {
    return user.email;
  }

  return user.username;
};

export const useConfigurationChangelogUsers = () => {
  const query = useUnpaginatedUsers({ pageSize: 100 });

  const usersById = useMemo(
    () =>
      new Map<number, User>((query.data ?? []).map(user => [user.id, user])),
    [query.data]
  );

  return { ...query, usersById };
};
